/**
 * TYPE cell for an invoice line: billed time, a reimbursable expense, media
 * sold (a line priced from a product-sale rate, 0059), or a fee.
 *
 * A client reading "Macbook Air E26 — $1,299.00" next to hours has no way to
 * tell a pass-through cost from professional services. The source ids already
 * say which is which (migrations 0038/0039), so nothing is stored for this.
 *
 * Mirrors `invoiceLineType` in packages/api/src/pdf/invoice.ts — the screen and
 * the PDF must label a line the same way. Kept as two copies rather than a
 * shared module, matching how `formatDiscountPct` is already duplicated.
 */
export function invoiceLineType(
  line: { time_entry_id?: number | null; expense_id?: number | null; is_product_sale?: boolean | null },
): 'Time' | 'Expense' | 'Media' | 'Fee' {
  if (line.expense_id != null) return 'Expense';
  if (line.is_product_sale) return 'Media';
  if (line.time_entry_id != null) return 'Time';
  return 'Fee';
}
